import { createContext } from './context';
var ConfigContext = createContext({});
export default ConfigContext;